import loadable from "@loadable/component";
import { useParams } from "react-router-dom";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePatchHook from "../../customHooks/usePatchHook";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useState } from "react";
import Spinner from "../../Components/Reusable/Spinner";
const EditPickupNoteComponent = loadable(
  () => import("../../Components/PickupNotes/SwitchTab")
);
const EditPickupNote = () => {
  const { id } = useParams();
  const [defaultValue, setDefaultValue] = useState(null);
  const { data, refetch, isLoading } = useGetHook({
    queryKey: [`pickup-notes-${id}`],
    url: `${APIS.PICKUP_NOTES}${id}/`,
    params: {},
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: [`pickup-notes-${id}`, "pickup-note"],
    navigateURL: "/",
  });

 
  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.PICKUP_NOTES}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
   const { mutateAsync: toggleMarkAsDone, isLoading: isMarkAsDoneLoading } =
    usePatchHook({
      queryKey: [`pickup-notes-${id}`, "pickup-note"],
      navigateURL: "/edit:id",
    });

  const handleMarkAsDone = async (values: any, setError: any) => {
    const url = `${APIS.PICKUP_NOTES}${id}/`;
    let formData = {
      is_pickup_note_complete: true,
    };
    try {
      await toggleMarkAsDone({ url, formData, setError });
      await refetch();
    } catch (err) {
      console.log(err);
    }
  };



 

  return (
    <div>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Pickup Note
        </span>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <EditPickupNoteComponent
          isLoading={isPatchLoading}
          data={data}
          handleUpdate={handleEdit}
          defaultValue={defaultValue}
          setDefaultValue={setDefaultValue}
          id={id}
          handleMarkAsDone={handleMarkAsDone}
        />
      )}
    </div>
  );
};

export default EditPickupNote;
